'use client';

import { NAMESPACE, useLang } from '@/hooks/use-lang';
import Link from 'next/link';
import { Trans } from 'react-i18next';
import { useEventTracking } from '@/shared/tracking/use-tracking';
import { getContactUsLink } from '@/app/utils/get-contact-us-link';

export default function NotFoundSearchResult({ query = '' }: { query?: string }) {
  const { t, lang } = useLang(NAMESPACE.search);
  const { trackEvent } = useEventTracking();
  return (
    <div className="flex flex-col gap-y-8">
      <span className="font-medium text-3xl mt-[3%]">{t('no.results.found')}</span>
      <span dangerouslySetInnerHTML={{ __html: t('not.return.any.results', { query: query }) }}></span>
      <span>
        <Trans
          t={t}
          i18nKey="no.results.des"
          components={[
            <Link
              target="_blank"
              key="customer_support"
              href={getContactUsLink(lang)}
              onClick={() => {
                trackEvent({
                  key: 'search',
                  action: 'search:continue',
                  payload: {
                    searchType: 'product',
                    keyword: query,
                    continueAction: 'Customer Support',
                  },
                });
              }}
            ></Link>,
          ]}
        />
      </span>
      <div className="h-px bg-gray-500"></div>
      <div>
        <span className="font-medium text-xl">{t('search.tip')}</span>
        <ul>
          <Trans t={t} i18nKey="search.tip.des" components={[<li key="tip"></li>]} />
        </ul>
      </div>
    </div>
  );
}
